<script setup lang="ts">
/**
 * How often the pharmacy handed a product over within the year of the scan,
 * and when it last did, as a tag at the foot of the line.
 */
import {TreatmentLineHistory} from "@/medication-checkup/interfaces/treatment-selections";

defineProps<{
    history: TreatmentLineHistory;
}>();
</script>

<template>
  <span
    class="self-end whitespace-nowrap rounded-full bg-gray-light px-1.5 py-px text-[10px] font-semibold text-muted-foreground"
    :title="`Délivré ${history.dispensings} fois en 12 mois`"
  >
    {{ history.dispensings }}× en 12 mois<template v-if="history.last_dispensed_at"> · dernière le {{ $filters.date(history.last_dispensed_at, 'short') }}</template>
  </span>
</template>
